import { Component } from "@angular/core";
import {
  faSave,
  faPrint,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { CardsDepositListingService } from "src/app/services/autopac/cards-deposit-listing.service";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-cards-deposit-listing",
  templateUrl: "./cards-deposit-listing.component.html",
  styleUrls: ["./cards-deposit-listing.component.css"],
})
export class CardsDepositListingComponent {
  faSave = faSave;
  faPrint = faPrint;
  faLink = faLink;

  showTable: boolean = false;

  form: FormField[] = [
    {
      type: "date",
      id: "ReceiptDate",
      label: "Receipt Date (dd/mm/yyyy)",
    },
    {
      type: "text",
      id: "DepositName",
      label: "Deposit's Name",
      value: "KOMOCO MOTORS PTE LTD",
    },
    {
      type: "text",
      id: "DepositAccountNumber",
      label: "Deposit's Account Number",
      value: "001 - 062637 - 0",
    },
    {
      type: "const",
      id: "TotalReceiptAmount",
      label: "Total Receipt Amount",
      value: null,
    },
  ];

  headers = [
    {
      title: "FINANCE COMPANY",
      type: "data",
      classes: "max-w-64",
      id: "BankName",
    },
    {
      title: "TERMINAL NO",
      type: "data",
      classes: "max-w-64",
      id: "TerminalNo",
    },
    {
      title: "BATCH NO",
      type: "data",
      classes: "max-w-64",
      id: "BatchNo",
    },
    {
      title: "INVOICE NO",
      type: "data",
      classes: "max-w-64",
      id: "InvoiceNo",
    },
    {
      title: "OR NUMBER",
      type: "data",
      classes: "max-w-64",
      id: "OrNumber",
    },
    {
      title: "CONTRACT NUMBER",
      type: "data",
      classes: "max-w-64",
      id: "ContractNo",
    },
    {
      title: "SALES CONSULTANT",
      type: "data",
      classes: "max-w-64",
      id: "Salesman",
    },
    {
      title: "RECEIPT AMOUNT",
      type: "data",
      classes: "max-w-64",
      id: "ReceiptAmount",
    },
    {
      title: "BANK IN",
      type: "checkbox",
      id: "BankIn",
    },
  ];

  entries: {
    BankIn: boolean;
    BankName: string;
    BatchNo: string;
    ContractNo: string;
    CustomerName: string;
    InvoiceNo: string;
    OrNumber: string;
    ReceiptAmount: string;
    Salesman: string;
    TerminalNo: string;
  }[] = [];

  constructor(
    private cardsDepositListingService: CardsDepositListingService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    const today: Date = new Date();
    this.getField("ReceiptDate").value = this.datePipe.transform(
      today,
      "yyyy-MM-dd",
    )!;
  }

  showReceipt(): void {
    const receiptDate = this.getField("ReceiptDate").value;
    this.cardsDepositListingService
      .GetReceipts(
        this.datePipe.transform(receiptDate, "dd/MM/yyyy")!,
      )
      .subscribe({
        next: (response) => {
          this.showTable = true;
          this.getField("TotalReceiptAmount").value =
            response.message;
          this.entries = response.body;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  print(mode: string): void {
    const receiptDate = this.getField("ReceiptDate").value;

    const model = {
      DepositAccountNumber: this.getField("DepositAccountNumber")
        .value,
      DepositName: this.getField("DepositName").value,
      ReceiptDate: this.datePipe.transform(receiptDate, "dd/MM/YYYY"),
      Items: this.entries,
    };

    const request$ =
      mode === "pdf"
        ? this.cardsDepositListingService.print(model)
        : this.cardsDepositListingService.export(model);

    request$.subscribe({
      next: (response) => {
        const url =
          mode === "pdf" ? response.body.Name : response.body.Value;

        window.open(url, "_blank");
      },
      error: (error) => console.log(error),
    });
  }

  getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }

  clear(): void {
    this.form.forEach((item) => {
      item.value = undefined;
    });
  }
}
